<template>
  <div :style="{ height: tableHeight }">
    <Spreadsheet
      :headers="headersWithRules"
      :items="users"
      :notDesiredHeaders="['createdAt', 'verified', 'auths', 'UUID', 'fullName']"
      :loadingData="loadingUsers && isTableEditingMode"
      style="height: 100%"
      @updateItemInline="updateUserInline($event.value, $event.rowIndex, $event.header)"
    />
    <v-row align="center" justify="space-between" class="flex-wrap">
      <v-col cols="1" class="pb-0" v-show="$vuetify.breakpoint.mdAndUp">
        <v-btn color="kbGray" :loading="loadingUsers" style="cursor: default!important" text/>
      </v-col>
      <v-col cols="12" md="11" class="pb-0 d-flex align-center justify-center justify-md-end flex-wrap">
        <div class="d-flex align-center py-1">
          <span class="kbDark--text mr-4" style="font-size: 14px">
            {{ `${$t('general.people')} ${$t('general.perPage')}` }}
          </span>

          <v-menu v-model="isItemsPerPageMenuOpened">
            <template v-slot:activator="{ on }">
              <div class="d-flex align-center elevation-3 white pa-2" style="cursor: pointer; border-radius: 6px" v-on="on">
                <span class="kbDark--text mr-1" style="font-size: 14px">
                  {{ paginationUsers.itemsPerPage }}
                </span>
                <v-icon color="kbGray">{{ isItemsPerPageMenuOpened ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </div>
            </template>
            <v-list>
              <v-list-item v-for="(option, index) in itemsPerPageOptions"
                           :key="index"
                           @click="changeItemsPerPage(option)">
                <v-list-item-title>
                  {{ option }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <span class="kbDark--text ml-10" style="font-size: 14px">
            {{ `${1 + ((page - 1) * paginationUsers.itemsPerPage) }-` }}
            {{ page === numberOfPages ? totalUsers : page * paginationUsers.itemsPerPage || itemsPerPageOptions[0] }}
            {{ $t('general.of') }}
            {{ totalUsers }}
          </span>
        </div>

        <div class="py-1">
          <v-pagination
            color="mainButtons"
            circle
            :length="numberOfPages"
            :total-visible="6"
            v-model="page"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Spreadsheet from '@/components/Spreadsheet/Spreadsheet'
import { mapState } from 'vuex'
import countries from '@/libs/countries'
import rules from '@/libs/rules'

export default {
  components: { Spreadsheet },
  computed: {
    ...mapState({
      isTableEditingMode: state => state.dataTables.isTableEditingMode,
      loadingUsers: state => state.users.loadingUsers,
      paginationUsers: state => state.users.paginationUsers,
      totalUsers: state => state.users.totalUsers
    }),
    headersWithRules () {
      if (!this.headers || !Array.isArray(this.headers) || this.headers.length === 0) return []
      const headers = [...this.headers]
      return headers.map(item => {
        const headerRules = item.required ? [rules.required] : []
        if (item.type === 'email') {
          headerRules.push(rules.email)
        } else if (item.type === 'phone') {
          headerRules.push(rules.phoneNumber)
        }
        return { ...item, rules: headerRules }
      })
    },
    numberOfPages () {
      const { itemsPerPage } = this.paginationUsers
      if (!itemsPerPage) {
        return 1
      } else {
        return Math.ceil(this.totalUsers / itemsPerPage)
      }
    },
    page: {
      get () {
        return this.paginationUsers.page || 1
      },
      set (value) {
        const { page, ...all } = this.paginationUsers
        this.$store.commit('SET_PAGINATION_USERS', {
          page: value,
          ...all
        })
      }
    },
    tableHeight () {
      const { smAndDown, lgAndDown } = this.$vuetify.breakpoint
      if (smAndDown) return '65vh'
      if (lgAndDown) return '78vh'
      return '85vh'
    }
  },
  data () {
    return {
      isItemsPerPageMenuOpened: false
    }
  },
  methods: {
    changeItemsPerPage (option) {
      const { itemsPerPage, page, ...all } = this.paginationUsers
      this.$store.commit('SET_PAGINATION_USERS', {
        page: 1,
        itemsPerPage: option,
        ...all
      })
    },
    updateUserInline (value, userIndex, header) {
      let key = header.value
      let secondKey = ''
      if (key && key !== 'name' && key !== 'lastName' && key !== 'email' && key !== 'phone') {
        secondKey = key
        key = 'extraData'
      }
      if (header.type === 'phone') {
        const trimmedValue = value.trim()
        const parenthesesRegex = /\(([^)]+)\)/
        const countryCode = parenthesesRegex.exec(trimmedValue)[1]
        const countryObj = countries.find(item => item.number === countryCode)
        const phone = trimmedValue.split(')')[1]
        if (key === 'phone') {
          value = { phone, code: countryObj.code, number: countryObj.number }
        } else {
          value = { phone, code: countryObj.code, country: countryObj.country, number: countryObj.number }
        }
      }
      this.$emit('updateUserInline', { data: { key, secondKey, value }, userIndex })
    }
  },
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    itemsPerPageOptions: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      default: () => []
    }
  }
}
</script>
